import React from 'react';
import Terminal from '../../molecules/bluePrintComponents/BottomTerminal';
import ImageMapEditor from '../../molecules/dashboardBuilder/ImageMap/ImageMapEditor';

const Hoc = (WrappedComponent) => {
  const Wrapper = (props) => {
    const dragSave = React.useRef();

    const {match: {params = {}} = {}, ...rest} = props;

    const extraProps = {
      dragSave,
      params,
      ...rest,
    };

    return (
      <React.Fragment>
        <ImageMapEditor/>
        <WrappedComponent {...extraProps} />
        <Terminal newUi />
      </React.Fragment>
    );
  };
  return Wrapper;
};

export default Hoc;
